import * as d3 from 'd3'
export default {

  methods: {

    draw_Status() {

      let bar = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.status.x + .5}, ${this.status.y + .5})`)

      let barLen = (this.status.width/100) * this.gmx_Progress(this.rawData.CREATED, this.rawData.ACTIVE)

      bar
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('rx', this.status.bar.radius)
      .attr('width', this.status.width).attr('height', 8)
      .attr('fill', this.columns.find(f=> f.code == 'CREATED').bColor).attr('stroke-width', 0)
      .attr('opacity', .5)

      bar
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('rx', this.status.bar.radius)
      .attr('width', barLen).attr('height', 8)
      .attr('fill', this.columns.find(f=> f.code == 'ACTIVE').bColor).attr('opacity', .7)

      bar // Active
      .append('text')
      .attr('x', 1).attr('y', -11)
      .attr('fill', this.status.active.tColor).attr('font-size', this.status.active.tSize)
      .attr('text-anchor', 'start')
      .text(this.rawData.ACTIVE)
      .call(this.event_Link, this.columns.find(f=> f.code=='ACTIVE'))

      bar // Active
      .append('text')
      .attr('x', 2).attr('y', -2)
      .attr('fill', '#F7BACF').attr('font-size', 9)
      .attr('text-anchor', 'start')
      .text(this.columns.find(f=> f.code == 'ACTIVE').name)


      let status = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.status.x + .5}, ${this.status.y + .5 - this.status.height})`)

      this.columns.forEach(col=> {
        if(col.code == 'ACTIVE') return

        status // Name
        .append('text')
        .attr('x', col.ex).attr('y', this.status.name.tSize*0.75)
        .attr('fill', this.status.name.tColor).attr('font-size', this.status.name.tSize)
        .attr('text-anchor', 'end')
        .text(col.name)

        status // Value
        .append('text')
        .attr('x', col.ex).attr('y', this.status.value.y + this.status.value.tSize*0.75)
        .attr('fill', this.status.value.tColor).attr('font-size', this.status.value.tSize)
        .attr('text-anchor', 'end')
        .text(this.rawData[col.code])
        .call(this.event_Link, col)

      })

    },

  } 
}